/* eslint-disable linebreak-style */
'use client'

import {useEffect} from 'react'
import {useParams} from 'next/navigation'

type Props = {
  nBroadNo?: string
}
const LoadScript = ({
  nBroadNo,
}: Props) => {
  //   const {liveStreamData} = useLivestreamPlayer()
  const params = useParams()
  const bjId = params.bjId as string
  // const broadNo = params.broadNo as string

  useEffect(() => {
    // Hàm chèn script và đợi script load xong
    const loadScript = (
      src: any,
      type = 'text/javascript',
      charset = 'utf-8',
    ) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = src
        script.type = type
        script.charset = charset
        script.onload = resolve
        script.onerror = reject

        // Chèn script lên đầu thẻ htmlplayer_content
        const targetElement = document.querySelector('.htmlplayer_content')
        if (targetElement) {
          targetElement.insertBefore(script, targetElement.firstChild)
        } else {
          console.log('Element not found')
        }
      })
    }

    // Hàm chính để load các script lần lượt
    const loadAllScriptsSequentially = async () => {
      try {
        await loadScript(
          'https://static.onlive.vn/asset/service/config/constant.js?_=202108031200',
        )
        await loadScript(
          'https://static.onlive.vn/asset/app/liveplayer/player/dist/vendor.js?_=20241101',
        )
        await loadScript(
          'https://static.onlive.vn/asset/app/liveplayer/player/dist/LivePlayer.js?_=20241101',
        )
        await loadScript(
          'https://static.onlive.vn/asset/app/liveplayer/view/dist/ViewVendor.js?_=20241101',
        )
        await loadScript(
          'https://static.onlive.vn/asset/app/liveplayer/view/dist/LiveView.js?_=20241101',
        )
        await loadScript(
          'https://static.onlive.vn/asset/service/common/common_analysis.js',
        )
        // await loadScript(
        //   'https://cdn.onplay.live/sdk/web/latest/onlive.min.js?v=202408201129',
        // )

        // Inline script to attach LiveOverlay
        if (typeof window !== 'undefined' && window.LiveOverlay) {
          const liveOverlay = window.LiveOverlay
          console.log('111343443', liveOverlay)
          const layout = document.getElementById('videoLayer')

          liveOverlay.attachTo(layout)
          liveOverlay.join({
            mediaContentId: `${bjId}`,
            deviceType: 'web',
            type: 1,
          })
        }
        // Chèn script inline cuối cùng

        const inlineScript = document.createElement('script')
        inlineScript.innerHTML = `
          var bEmbed = false;
          var isSimpleMode = false;
          var szLang = 'vi_VN';
          var szLocalCode = 'VN';
          var livePlayer = null;
          var liveView = null;
          var szBjId = '${bjId}';
          var szBjNick = '';
          var nBroadNo = ${nBroadNo};
          var szBroadTitle = '';
          var szBroadThumPath = '';
          var isDev = true;
          var szMode = 'landing';
          var defaultConfig = 'https://static.onlive.vn/asset/service/config/config.js';
          var ver = '';
          var szInflow = '';

          var categories = {
            '00010000': 'Trò chơi',
            '00010016': 'PUBG PC',
          };

          if (szLocalCode != 'KR') {
            defaultConfig = 'https://static.onlive.vn/asset/service/config/config_global.js';
          }

          $(document).ready(function () {
            livePlayer = new LivePlayer({
              isDev: isDev,
              mode: szMode,
              inflow: szInflow,
              language: szLang,
              mutePlay: true,
            });
            liveView = new LiveView(livePlayer.externalInterface, {
              isDev: isDev,
              mode: szMode,
              language: szLang,
              isSimpleMode: isSimpleMode,
            });

            liveView.isLoaded().then(function () {
              if (document.location.search.indexOf('fromApi=') === -1) {
                livePlayer.loadBroad(szBjId, nBroadNo);
              }
            });
          });

          function setClickLog(szCodetype, szSendData, szSysType) {
            try {
              oAnalysisUtil.setClickLog(
                szCodetype,
                szSendData,
                typeof szSysType == 'undefined' || szSysType == null
                  ? 'html5'
                  : szSysType
              );
            } catch (e) {}
          }
        `

        const targetElement = document.querySelector('.htmlplayer_content')
        if (targetElement) {
          targetElement.insertBefore(inlineScript, targetElement.firstChild)
        }
      } catch (error) {
        console.error('Failed to load scripts:', error)
      }
    }

    // Gọi hàm để load các script lần lượt
    loadAllScriptsSequentially()
  }, [])

  return <></>
}

export default LoadScript
